import React, { useEffect, useState } from 'react'
import styled, { css } from 'styled-components'
import suki from '../../lib/assets/icons/suki.png'
import { lemonGinger } from '../../styles/colors'
import { BREAKPOINT } from './constants'

const MainContainer = styled.div`
  width: 100%;
  height: 100%;
  
  display:flex;
  flex-direction: column;
  align-items:center;
`
const HorizontalContainer = css`
  width: 100%;
  height: 50%;
  
  display:flex;
  flex-direction: row;
  align-items:center;
  
  @media (max-width: ${BREAKPOINT.SMALL}) {
    height: 100%;
    flex-direction: column;
  }
`
const TopContainer = styled.div`
  ${HorizontalContainer}
  background: #2E5F62;
`
const BottomContainer = styled.div`
  ${HorizontalContainer}
  background: #f0f4ef;
  background-size: 100% 100%;
`
const ContentContainer = styled.div`
  width: 100%;
  height: 90%;
  margin: 4% 4% 2%;

  display:flex;
  flex-direction: row;
  align-items: ${props => (props.alignVerticalCenter ? 'center' : 'flex-start')}; 

  @media (max-width: ${BREAKPOINT.SMALL}) {
    flex-direction: column;
  }
`
const SectionContainer = styled.div`
  width:  ${props => (props.left ? '40%' : '60%')}; 
  height: 100%;
  padding: ${props => (props.extraRightIndent ? '0 7% 0 3%' : '0 5%')};
  
  color:  ${props => (props.textColor === 'white' ? 'white' : 'black')};
  font-size: ${props => (props.biggerFont ? '1.1em' : '1em')};

  display:flex;
  flex-direction: column;
  align-items: ${props => (props.right ? 'flex-start' : 'flex-end')};
  
  border-left: ${props => (props.borderLeft && '0.5px outset black')};
  
  @media (max-width: ${BREAKPOINT.SMALL}) {
    width: 80%;
    padding: 10%;
  }
`
const SukiLogo = styled.div`
  width: 275px;
  height: 75px;
  background-image: url(${suki}) ;
  background-size: 100% 100%;
  
  display:flex-center;
  flex-direction: column;
  align-items:center;

   @media (max-width: ${BREAKPOINT.MEDIUM}) {
      width: 195px;
      height: 50px;
  }
`
const TextSection = styled.p`
  text-align: ${props => (props.alignRight ? 'right' : 'left')};
  line-height: 30px;
  margin-top: 5%;
`

const StyledA = styled.a`
  font-size: 14px;
  font-weight: 400;
  text-decoration: underline;
  line-height: 28px;
  margin-top: 24px;
  color: inherit;
`

const RegularTextSection = styled.p`
  text-align: left;
  line-height: normal;
  margin: 5px 0;
  
  ul {
    margin: 0;
    li{
        margin: 5px 0;
    }
  }
`
const WindowsDownloadBtn = styled.a`
  width: 200px;
  height: 40px;
  
  display:flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  
  margin: 25px 0 5px;
  
  cursor: pointer;
  text-decoration: none;
  color: black;
  background: #fcf238;
  border-radius: 20px;
  
  &:hover {
    background-color: ${lemonGinger};
  }
`
const Label = styled.span`
  font-style: ${props => (props.italic && 'italic')};
  font-size: ${props => {
    if (props.big) return '2em'
    else if (props.medium) return '28px'
    else if (props.small) return '25px'
    else if (props.xsmall) return '18px'
    else return '20px'
  }};
  font-weight: ${props => (props.bold ? '600' : '400')};
  margin: ${props => (props.indentTop || '0px')} 0px ${props => (props.indentBottom || '5px')}  0px ;
`

const DownloadLink = (isDotNet3 = false) => {
  let env = window.location.hostname

  // if app runs on localhost or some other env 'app.suki-dev.com' link will be used
  if (window.location.hostname !== 'app.suki-test.com' &&
    window.location.hostname !== 'app.suki-stage.com' &&
    window.location.hostname !== 'app.suki.ai') env = 'app.suki-dev.com'

  if (isDotNet3) {
    return `https://storage.googleapis.com/windows-${env}/SukiAssistantSetup(.NETCore3.1).msi`
  }
  return `https://storage.googleapis.com/windows-${env}/SukiAssistantSetup.msi`
}

const HOW_TO_INSTALL_WINDOWS_LINK = 'https://help.suki.ai/en/articles/5434271-installing-the-suki-assistant-windows-app'

const DownloadSukiWindowsAppComponent = () => {
  return (
    <>
      <Label small>Download the</Label>
      <Label big>Suki Assistant Windows app</Label>
      <TextSection>
        The Suki Assistant Windows app lets you use the intelligence of Suki to
        dictate in any field or application on a Windows computer. Download the
        latest version now.
      </TextSection>
      <WindowsDownloadBtn href={DownloadLink()}>
        Download for .NET 6.0
      </WindowsDownloadBtn>
      <StyledA href={DownloadLink(true)}>Or download for .NET 3.1</StyledA>
      <p style={{fontSize: "14px"}}>
        Need Help?{" "}
        <StyledA href={HOW_TO_INSTALL_WINDOWS_LINK}>
          Learn how to install Windows.
        </StyledA>
      </p>
    </>
  )
}

const DownloadVersionComponent = ({version, date}) => {
  return (
    <>
      <Label medium bold indentBottom='35px'>Whatʼs new in this version?</Label>
      <TextSection alignRight>
        <Label bold>Version:</Label> <Label>{version}</Label>  <br />
        <Label bold>Date:</Label> <Label>{date}</Label>
      </TextSection>
    </>
  )
}

const ReleaseNotesComponent = ({description, notes = [], issues = []}) => {
  return (
    <>
      <Label bold indentBottom='13px'>Release notes</Label>
      <RegularTextSection>{description}</RegularTextSection>

      <Label xsmall bold indentTop='15px' indentBottom='10px'>With this release, you can:</Label>
      <RegularTextSection>
        <ul>
          {notes.map((note, idx) => <li key={idx}>{note}</li>)}
        </ul>
      </RegularTextSection>

      <Label xsmall bold indentTop='10px' indentBottom='3px'>Known issues</Label>
      <RegularTextSection>
        <ul>
          {issues.map((issue, idx) => <li key={idx}>{issue}</li>)}
        </ul>
      </RegularTextSection>
    </>
  )
}

const WindowsDownload = () => {
  useEffect(() => {
    const {protocol, hostname} = document.location
    const devUrl = 'https://api.suki-dev.com'
    const url = hostname.includes('localhost') ? devUrl : `${protocol}//${hostname.replace('app', 'api')}`
    fetch(`${url}/v1/windows-release-notes`)
      .then(response => response.json())
      .then(data => setReleaseData(data[0]))
      .catch(error => console.log(error));
  }, [])

  const [releaseData, setReleaseData] = useState({})
  const { version, date, description, notes, issues } = releaseData

  return (
    <MainContainer>
      <TopContainer>
        <ContentContainer alignVerticalCenter>
          <SectionContainer left>
            <SukiLogo />
          </SectionContainer>
          <SectionContainer right textColor='white' biggerFont>
            <DownloadSukiWindowsAppComponent />
          </SectionContainer>
        </ContentContainer>
      </TopContainer>
      <BottomContainer>
        <ContentContainer>
          <SectionContainer left extraRightIndent>
            <DownloadVersionComponent version={version} date={date} />
          </SectionContainer>
          <SectionContainer right borderLeft>
            <ReleaseNotesComponent description={description} notes={notes} issues={issues}/>
          </SectionContainer>
        </ContentContainer>
      </BottomContainer>
    </MainContainer>
  )
}

export default WindowsDownload
